module.exports = __webpack_public_path__ + "static/img/title.c9461a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-4/title.png
// module id = KoLE
// module chunks = 0